define('controllers/mysetting/mysetting',['app', 'mainCons'], function (app, mainCons) {

    app.controller('MySetting', ['$q', '$stateParams', '$location', '$state', 'auiDialog', '$scope', 'UserInfo', '$rootScope',
        function ($q, $stateParams, $location, $state, auiDialog, $scope, UserInfo, $rootScope) {
            var Model = $scope.Model = {};
            Model.userTypePer = 1;
            Model.userTypeCorp = 2;
            Model.isShowMune = true;

            $rootScope.menuIsActive = mainCons.modUserinfoConstant.mysetChildMenu.userInfo;


            Model.triggShowmenu = function () {
                if (Model.isShowMune) {
                    Model.isShowMune = false;
                } else {
                    Model.isShowMune = true;
                }
            };

            init();

            function init() {
                if ($location.url().split('/')[2] != "teamAccountInfoList") {
                    UserInfo.updateCache();
                }
                Model.isNotShowFooter = ($location.url().split('/')[2] == "teamAccountInfoList"
                    || $location.url().split('/')[2] == "modUserInfoCorp" ||
                    $location.url().split('/')[2] == "modUserInfoPer" ||
                    $location.url().split('/')[2] == "memberDetail" ||
                    $location.url().split('/')[2] == "accountGroup" ||
                    $location.url().split('/')[2] == "modPayService"
                    || ($location.url().split('/')[2].indexOf("validCorpattion") !== -1 || $location.url().split('/')[2].indexOf("validResult") !== -1
                        || $location.url().split('/')[2] == "modBussnessInfo"
                    ));
            }
        }]);
});

